export default function Luggage() {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 36.8 33.3"
    //   style="enable-background:new 0 0 36.8 33.3;"
      xmlSpace="preserve"
    >
      <g id="luggage" transform="translate(0.15 -20.45)">
        <g id="Group_10866" transform="translate(0 20.6)">
          <g id="Group_10865" transform="translate(0 0)">
            <g id="Path_2180">
              <path
                className="st0"
                d="M34.9,6.3c-1-1-2.4-1.6-3.8-1.6h-5.8V2.9c0-0.7-0.3-1.5-0.8-2l0,0c-0.5-0.5-1.3-0.8-2-0.8h-8.2
					c-1.6,0-2.9,1.3-2.9,2.9v1.9H5.4c-3,0-5.4,2.4-5.4,5.4v17.5c0,3,2.4,5.4,5.4,5.4h25.7c3,0,5.4-2.4,5.4-5.4V10.1
					C36.5,8.7,35.9,7.3,34.9,6.3z M12.6,2.9L12.6,2.9c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.4,1.1-0.4h8.2c0.4,0,0.8,0.2,1.1,0.4l0,0
					c0.3,0.3,0.4,0.7,0.4,1v1.9h-1.3V4.1c0-0.5-0.2-0.9-0.6-1.2l0,0c-0.4-0.3-0.9-0.5-1.4-0.5h-4.7c-0.5,0-1,0.2-1.4,0.5
					c-0.4,0.3-0.6,0.8-0.6,1.3v0.6h-1.4V2.9z M21.2,4.2v0.6h-6V4.1c0-0.1,0.1-0.2,0.1-0.3c0.1-0.1,0.3-0.2,0.5-0.2h4.7
					c0.2,0,0.3,0.1,0.5,0.2l0,0C21.2,4,21.2,4.1,21.2,4.2z M34,30.5c-0.8,0.8-1.8,1.2-2.9,1.2H5.4c-1.1,0-2.1-0.4-2.9-1.2
					c-0.8-0.8-1.2-1.8-1.2-2.9V10.1c0-1.1,0.4-2.1,1.2-2.9c0.8-0.8,1.8-1.2,2.9-1.2h25.7c1.1,0,2.1,0.4,2.9,1.2
					c0.8,0.8,1.2,1.8,1.2,2.9v17.5h0C35.1,28.7,34.7,29.7,34,30.5z"
              />
              <path
                className="st0"
                d="M31.1,33.2H5.4c-3,0-5.5-2.5-5.5-5.5V10.1c0-3,2.5-5.5,5.5-5.5h5.7V2.9c0-1.7,1.4-3,3-3h8.2
					c0.8,0,1.6,0.3,2.1,0.9l0,0c0.6,0.6,0.9,1.3,0.9,2.1v1.7h5.7c1.5,0,2.9,0.6,3.9,1.6c1,1,1.6,2.5,1.6,3.9v17.5
					C36.6,30.6,34.1,33.1,31.1,33.2z M5.4,4.9c-2.9,0-5.2,2.4-5.3,5.3v17.5c0,2.9,2.4,5.2,5.3,5.3h25.7c2.9,0,5.2-2.4,5.2-5.3V10.1
					c0-1.4-0.6-2.7-1.5-3.7l0,0c-1-1-2.3-1.5-3.7-1.5h-6v-2c0-0.7-0.3-1.4-0.8-1.9l0,0c-0.5-0.5-1.2-0.8-1.9-0.8c0,0,0,0,0,0h-8.2
					c-1.5,0-2.7,1.2-2.7,2.7v2H5.4z M31.1,31.8C31.1,31.8,31.1,31.8,31.1,31.8H5.4c-1.1,0-2.2-0.4-3-1.2c-0.8-0.8-1.2-1.9-1.2-3
					V10.1c0-1.1,0.4-2.2,1.2-3c0.8-0.8,1.9-1.2,3-1.2c0,0,0,0,0,0h25.7c1.1,0,2.2,0.4,3,1.2c0.8,0.8,1.2,1.9,1.2,3l0,17.3l0,0.2
					c0,1.1-0.4,2.2-1.2,3l0,0C33.3,31.4,32.2,31.8,31.1,31.8z M31.1,31.5c1,0,2-0.4,2.8-1.1c0.7-0.7,1.1-1.6,1.1-2.6l0-0.1V10.1
					c0-1-0.4-2-1.1-2.8c-0.7-0.7-1.7-1.1-2.8-1.1H5.4c0,0,0,0,0,0c-1,0-2,0.4-2.7,1.1c-0.7,0.7-1.1,1.7-1.1,2.8v17.5
					c0,1,0.4,2,1.1,2.8c0.7,0.7,1.7,1.1,2.8,1.1H31.1z M24,4.9h-1.6V4.1c0-0.4-0.2-0.9-0.5-1.1l0,0c-0.3-0.3-0.8-0.5-1.2-0.5
					c0,0,0,0,0,0h-4.7c-0.5,0-0.9,0.2-1.3,0.5c-0.3,0.3-0.5,0.7-0.6,1.2v0.8h-1.7V2.7h0c0-0.4,0.2-0.8,0.5-1
					c0.3-0.3,0.7-0.5,1.2-0.5h8.2c0,0,0,0,0,0c0.4,0,0.9,0.2,1.2,0.5l0,0C23.8,2,24,2.4,24,2.9V4.9z M22.7,4.6h1V2.9
					c0-0.4-0.1-0.7-0.4-0.9l0,0c-0.3-0.3-0.6-0.4-1-0.4h-8.2c-0.4,0-0.7,0.1-1,0.4c-0.3,0.3-0.4,0.6-0.4,1l0,0.2h0v1.6h1.1V4.1
					c0-0.5,0.3-1,0.7-1.4c0.4-0.3,0.9-0.5,1.4-0.5h4.7c0,0,0,0,0,0c0.5,0,1,0.2,1.4,0.5l0,0c0.4,0.3,0.6,0.8,0.6,1.4V4.6z M21.4,4.9
					h-6.3V4.1c0-0.2,0.1-0.3,0.2-0.4c0.2-0.1,0.4-0.2,0.6-0.2h4.7c0.2,0,0.4,0.1,0.6,0.2l0,0c0.1,0.1,0.2,0.2,0.2,0.4l0,0V4.9z
					 M15.4,4.6h5.7V4.2c0-0.1,0-0.1-0.1-0.2l0,0c-0.1-0.1-0.2-0.1-0.4-0.1h-4.7c-0.1,0-0.3,0-0.4,0.1c0,0-0.1,0.1-0.1,0.2L15.4,4.6z
					"
              />
            </g>
          </g>
        </g>
        <g id="Group_10868" transform="translate(8.613 29.922)">
          <g id="Group_10867">
            <g id="Path_2181">
              <path
                className="st0"
                d="M19,12l-1.4-1.4c-0.2-0.2-0.4-0.2-0.7-0.2l-2.5,0.8l-3-3.2L18,4.4c0.1,0,0.1-0.1,0.2-0.1
					c0.3-0.2,0.3-0.7,0-0.9c0,0,0,0,0,0l-1.8-1.9c-0.2-0.2-0.4-0.2-0.7-0.2L7.4,3.8l-2.8-3l0-0.1C4.1,0.3,3.4,0,2.7,0
					C2,0,1.4,0.3,0.9,0.7L0.8,0.8L0.7,0.9C0.3,1.4,0,2,0,2.7c0,0.7,0.3,1.4,0.7,1.9l0.1,0.1l3,2.8l-2.5,8.3c-0.1,0.2,0,0.5,0.2,0.7
					l1.8,1.8c0,0,0.1,0.1,0.1,0.1c0.3,0.2,0.7,0.1,0.9-0.3c0,0,0,0,0,0L8,11.4l3.2,3l-0.7,2.5c-0.1,0.2,0,0.5,0.2,0.7L12,19
					c0,0,0.1,0.1,0.1,0.1c0.3,0.2,0.7,0.1,0.9-0.3c0,0,0,0,0,0l1.8-3.2v0l0.2-0.5l0.5-0.2c0,0,0,0,0.1,0l3.1-1.8
					c0.1,0,0.1-0.1,0.2-0.1C19.2,12.7,19.2,12.3,19,12C19,12,19,12,19,12z M15,13.7L14.4,14c-0.1,0.1-0.2,0.2-0.3,0.3L13.7,15
					l-1.4,2.4l-0.5-0.5l0.8-2.5c0.1-0.3,0-0.5-0.2-0.7L8.3,9.8c-0.3-0.3-0.7-0.2-0.9,0c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2l-3.7,6.6
					l-0.9-0.9l2.5-8.3c0.1-0.3,0-0.5-0.2-0.7L1.8,3.6l0,0C1.5,3.3,1.4,3,1.4,2.7c0-0.3,0.1-0.7,0.4-0.9l0,0l0,0
					c0.3-0.2,0.6-0.4,0.9-0.4c0.3,0,0.6,0.1,0.9,0.3l0,0L6.8,5C7,5.2,7.2,5.2,7.5,5.1l8.3-2.5l0.9,0.9L10,7.3
					C9.7,7.4,9.6,7.8,9.8,8.2c0,0,0,0,0,0c0,0,0.1,0.1,0.1,0.1l3.9,4.1c0.2,0.2,0.4,0.3,0.7,0.2l2.5-0.8l0.5,0.5L15,13.7z"
              />
              <path
                className="st0"
                d="M12.5,19.3c-0.1,0-0.3,0-0.4-0.1c0,0-0.1,0-0.1-0.1c0,0-0.1,0-0.1-0.1l-1.4-1.4c-0.2-0.2-0.3-0.5-0.2-0.8
					l0.7-2.4l-3-2.8l-3.6,6.5c-0.1,0.2-0.3,0.3-0.5,0.4c-0.2,0.1-0.4,0-0.6-0.1c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1-0.1l-1.8-1.8
					C1.1,16.3,1,16,1.1,15.7l2.5-8.2l-3-2.8c-0.5-0.5-0.8-1.2-0.8-2c0-0.7,0.3-1.4,0.8-2l0.1-0.1c0.5-0.5,1.2-0.8,2-0.8
					c0.7,0,1.4,0.3,2,0.8l0.1,0.1l2.7,2.9l8.2-2.5c0.3-0.1,0.6,0,0.8,0.2l1.8,1.9c0.3,0.3,0.3,0.9,0,1.2c-0.1,0.1-0.1,0.1-0.2,0.2
					l-6.4,3.5l2.8,3l2.4-0.7c0.3-0.1,0.6,0,0.8,0.2l1.4,1.4c0.3,0.3,0.3,0.8,0,1.1c-0.1,0.1-0.2,0.1-0.2,0.2L15.7,15c0,0,0,0-0.1,0
					l-0.4,0.2L15,15.7l-1.8,3.2C13,19.2,12.8,19.3,12.5,19.3z M8,11.2l3.4,3.2L10.6,17c-0.1,0.2,0,0.4,0.1,0.5l1.4,1.4c0,0,0,0,0,0
					c0,0,0.1,0,0.1,0.1c0.2,0.1,0.5,0,0.7-0.2l1.8-3.2L15,15l0.5-0.3c0,0,0,0,0.1,0l3.1-1.7c0.1,0,0.1-0.1,0.2-0.1
					c0.2-0.2,0.2-0.5,0-0.7L19,12l-0.1,0.1l-1.4-1.4c-0.1-0.1-0.3-0.2-0.5-0.1l-2.6,0.8l-0.1-0.1L11.1,8l6.8-3.7
					c0.1,0,0.1-0.1,0.2-0.1c0.2-0.2,0.2-0.5,0-0.7l-1.8-1.9c-0.1-0.1-0.3-0.2-0.5-0.1L7.4,4L4.5,0.8C4,0.4,3.4,0.1,2.7,0.1
					c0,0,0,0,0,0C2.1,0.1,1.5,0.4,1,0.8L0.8,1C0.4,1.5,0.2,2.1,0.1,2.7c0,0.6,0.2,1.3,0.7,1.8l0.1,0.1l3,2.9l-2.5,8.4
					c-0.1,0.2,0,0.4,0.1,0.5l1.8,1.8c0,0,0,0,0.1,0c0,0,0.1,0,0.1,0.1c0.1,0,0.2,0.1,0.4,0c0.1,0,0.2-0.1,0.3-0.2L8,11.2z
					 M12.4,17.7L11.7,17l0.8-2.6c0.1-0.2,0-0.4-0.2-0.6L8.2,9.9C8,9.7,7.7,9.7,7.5,9.9c0,0.1-0.1,0.1-0.1,0.1l-3.8,6.7l-1.1-1.1
					l2.6-8.4c0.1-0.2,0-0.4-0.2-0.6L1.7,3.7c-0.3-0.3-0.4-0.6-0.4-1c0-0.4,0.2-0.8,0.4-1l0.1-0.1c0.3-0.3,0.7-0.4,1-0.4
					c0.4,0,0.7,0.1,1,0.4l0,0l3.1,3.3C7,5,7.2,5.1,7.4,5l8.4-2.5l1.1,1.1l-6.8,3.8C10,7.5,9.9,7.6,9.9,7.7s0,0.3,0,0.4
					c0,0,0,0,0.1,0.1c0,0,0,0,0,0l3.9,4.1c0.1,0.2,0.3,0.2,0.5,0.1l2.6-0.8l0.7,0.7l-2.6,1.5l-0.7,0.3c-0.1,0-0.2,0.1-0.2,0.2
					l-0.3,0.7L12.4,17.7z M12,16.9l0.3,0.3l1.3-2.3l0.3-0.7c0.1-0.2,0.2-0.3,0.4-0.4l0.7-0.3l2.3-1.3L16.9,12l-2.4,0.8
					c-0.3,0.1-0.6,0-0.8-0.2L9.8,8.4c0,0,0-0.1-0.1-0.1c0,0,0,0,0,0l0,0C9.5,8,9.5,7.8,9.6,7.6S9.8,7.2,10,7.1l6.5-3.6l-0.7-0.7
					L7.5,5.3c-0.3,0.1-0.6,0-0.8-0.2L3.6,1.8C3.3,1.6,3.1,1.5,2.8,1.5c-0.3,0-0.6,0.1-0.9,0.3L1.9,1.9C1.7,2.1,1.5,2.4,1.5,2.7
					c0,0.3,0.1,0.6,0.3,0.8l0,0l3.2,3.1c0.2,0.2,0.3,0.6,0.2,0.9l-2.5,8.2l0.7,0.7L7.2,10c0-0.1,0.1-0.1,0.1-0.2l0,0
					c0.3-0.3,0.8-0.3,1.1,0l4.1,3.8c0.2,0.2,0.3,0.6,0.2,0.9L12,16.9z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
